var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaymentMethodJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.95703,
    width: 21,
    height: 14.0857,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77547 7.94812C5.79407 7.19757 6.46314 6.54972 7.20872 6.53875C7.95322 6.53645 8.69784 6.53842 9.44234 6.53775C9.44029 9.04895 9.44637 11.5604 9.43927 14.0715C9.41059 14.8129 8.74881 15.4484 8.01136 15.4615C7.26544 15.4643 6.51945 15.4619 5.77351 15.4627V12.328C6.49806 12.4992 7.25787 12.572 7.99704 12.4585C8.43888 12.3874 8.92231 12.1704 9.0719 11.712C9.18198 11.3199 9.12 10.9073 9.13639 10.5048V9.57023H7.85718C7.85143 10.1883 7.86895 10.8075 7.84792 11.4249C7.81344 11.8044 7.43764 12.0455 7.07974 12.0326C6.63588 12.0373 5.75632 11.711 5.75632 11.711C5.75411 10.5528 5.7692 9.1025 5.77547 7.94823V7.94812Z",
    fill: "url(#paint0_linear_19695_104674)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7311 11.1805C15.054 11.1876 15.3787 11.1663 15.7003 11.1916C16.026 11.2523 16.1045 11.7454 15.8152 11.9069C15.6177 12.0132 15.3832 11.9465 15.1692 11.9652H14.7311V11.1805ZM15.887 10.2924C15.9588 10.5456 15.7147 10.7729 15.4708 10.738H14.7311C14.7363 10.4992 14.721 10.2401 14.7387 10.0139C15.035 10.0222 15.334 9.99685 15.6286 10.0271C15.7552 10.0589 15.8611 10.163 15.887 10.2924ZM17.6671 6.53737C17.6809 7.02093 17.6691 7.53005 17.6731 8.02342C17.6721 10.0293 17.675 12.0351 17.6715 14.0411C17.6585 14.7928 16.9923 15.446 16.2457 15.461C15.4985 15.4641 14.7511 15.4615 14.0037 15.4623V12.4299C14.818 12.4257 15.6327 12.4384 16.4467 12.4235C16.8243 12.3998 17.2379 12.1507 17.2554 11.7351C17.2999 11.3178 16.9064 11.0291 16.5329 10.9836C16.3893 10.9798 16.3935 10.9417 16.5329 10.9251C16.8892 10.8481 17.169 10.4793 17.0641 10.11C16.9748 9.72156 16.5455 9.57123 16.1884 9.57197C15.4603 9.56703 14.732 9.57128 14.0039 9.56984C14.0086 9.00372 13.9941 8.43699 14.0117 7.87129C14.0694 7.13311 14.7524 6.52436 15.4884 6.53756C16.2148 6.53745 16.941 6.53745 17.6671 6.53743V6.53737Z",
    fill: "url(#paint1_linear_19695_104674)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9195 9.94685C9.85217 9.96114 9.90596 9.71749 9.88875 9.62507C9.89334 9.04068 9.87916 8.45566 9.89657 7.87169C9.95409 7.13039 10.6423 6.52012 11.3814 6.53747H13.5577C13.5557 9.04867 13.5618 11.5601 13.5547 14.0712C13.526 14.8126 12.8641 15.4481 12.1267 15.4613C11.3807 15.4641 10.6347 15.4617 9.88872 15.4624V12.028C10.3982 12.446 11.0906 12.511 11.7254 12.5122C12.2039 12.512 12.6796 12.4382 13.1443 12.3279V11.6987C12.6206 11.9597 12.005 12.1255 11.4245 11.9755C11.0195 11.8747 10.7256 11.4834 10.7321 11.0654C10.6852 10.6308 10.9399 10.172 11.367 10.0428C11.8973 9.87681 12.4752 10.0038 12.9722 10.2196C13.0787 10.2754 13.1868 10.3445 13.1442 10.1665V9.67196C12.3129 9.47418 11.4283 9.4014 10.5931 9.61656C10.3514 9.68475 10.1159 9.78817 9.9195 9.94691V9.94685Z",
    fill: "url(#paint2_linear_19695_104674)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19695_104674",
    x1: 5.69545,
    y1: 11.0857,
    x2: 9.38218,
    y2: 11.0857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19695_104674",
    x1: 13.9787,
    y1: 10.809,
    x2: 17.6499,
    y2: 10.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19695_104674",
    x1: 9.88334,
    y1: 10.8956,
    x2: 13.5571,
    y2: 10.8956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodJcb);
export default __webpack_public_path__ + "static/media/icon_payment_method_jcb.8fbde93268d180c66f599baf6c44ebb1.svg";
export { ForwardRef as ReactComponent };